import React, { useMemo } from "react";

import { Tooltip } from "antd";

import dayjs from "dayjs";

export const TooltipCustom = ({ value, placement, children }) => {
    return(
        <Tooltip title={<TooltipTitle value={value} />} placement={placement} styles={{ root: { maxWidth: '500px' } }}>
            { children }
        </Tooltip>
    );
}

const TooltipTitle = ({ value }) => {
    const {
        api_method,
        diff_days,
        email_addr,
        error_code,
        first_date,
        key_code,
        last_date,
        nb_count,
        warning_level,
        warning_percent
    } = value;

    const dateFR = useMemo(() => ( 'DD/MM/YYYY' ), []);

    const defineCriticalErrorStatus = ( warningLevel ) => {
        if( warningLevel === 'high' ) return 'Haute';
        if( warningLevel === 'medium' ) return 'Moyenne';
        return 'Basse';
    }

    const isValid = ( key ) => {
        return value.hasOwnProperty(key)
            && value[key] !== null;
    }

    return (
        <div>
            {
                isValid('error_code') &&
                    <div>Code erreur : { error_code }</div>
            }
            {
                isValid('key_code') &&
                    <div>Utilisateur : { key_code }</div>
            }
            {
                isValid('api_method') &&
                    <div>Méthode de la requête : { api_method }</div>
            }
            {
                isValid('diff_days') &&
                    <div>Nb. jour(s) depuis la mise en échec : { diff_days }</div>
            }
            {
                isValid('email_addr') &&
                    <div>Adresse email en échec : { email_addr }</div>
            }
            {
                isValid('first_date') &&
                    <div>Date de la première entrée avant échec : { dayjs(first_date).format(dateFR) }</div>
            }
            {
                isValid('last_date') &&
                    <div>Date de la dernière entrée avant échec : { dayjs(last_date).format(dateFR) }</div>
            }
            {
                isValid('nb_count') &&
                    <div>Nb. élément(s) en échec : { nb_count }</div>
            }
            {
                isValid('warning_level') &&
                    <div>Criticité de l'erreur : { defineCriticalErrorStatus(warning_level) }</div>
            }
            {
                isValid('warning_percent') &&
                    <div>Pourcentage d'erreur : { warning_percent }</div>
            }
        </div>
    );
}